/*
 * Digital Purchase Order
 *
 * Copyright (c) 2016 LeBog Software GmbH, Germany.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are not permitted.
 */

import { API } from "./API/API";

var PasswordValidator = function(field, options, validate_obj) {
	var me = this;
	var server_response_cb = null;

	var tpl = `
    <span class="password-policy-light">
    {{if Messages.Length}}
    <span class="length">{{>Messages.Length}}</span>
    {{/if}}
    {{if Messages.Digits}}
    <span class="digits">{{>Messages.Digits}}</span>
    {{/if}}
    {{if Messages.LowerCase}}
    <span class="lower">{{>Messages.LowerCase}}</span>
    {{/if}}
    {{if Messages.UpperCase}}
    <span class="upper">{{>Messages.UpperCase}}</span>
    {{/if}}
    {{if Messages.SpecialChars}}
    <span class="special">{{>Messages.SpecialChars}}</span>
    {{/if}}
    </span>
    `;

	var tpl_error = `
		{{for ServerErrors}}
			<span class="error">{{>#data}}}</span>
		{{/for}}
	`;

  $.templates('PasswordPolicy', tpl);
  $.templates('PasswordPolicyError', tpl_error);


  this.registerResponseCB = function(cb) {
		if (typeof cb  === 'function') {
			server_response_cb = cb;
		}
	}

	options = $.extend(
		{
			UserID: null,
			EMail: null,
			UserData:[],
			Policy: {
				Length:0,
				LowerCase:0,
				UpperCase:0,
				Digits:0,
				SpecialChars:0,
				RepetitiveChars:0,
				Score: 0
			},
			Fields: {
				CurrentPassword:null,
				EMail:null,
				FirstName: null,
				LastName: null,
				PolicyDescription: null,
				Errors: null
			}
		},
		options
	);

	for(var xtraField in options.Fields) {
		if (typeof options.Fields[xtraField] == 'string') {
			options.Fields[xtraField]=$(options.Fields[xtraField]);
		}
	}

	var PolicyResult = function() {
		this.Errors = [];
		this.Pass = true;
		this.Score = 0;
		this.ScoreDescription='';
		this.Tests = {
			ComparePrevious: true,
			ContainsLogin: true,
			Differences: true,
			Digits: true,
			Empty: true,
			Length: true,
			LowerCase: true,
			NotChanged: true,
			RepetitiveChars: true,
			Score: true,
			SpecialChars: true,
			UpperCase: true,
			Whitespace: true,
		}
	};


	this.getRulesResult = function() {
		return Validate(field.val());
	}

	/**
	 * Local password validation
	 *
	 * @param   string    password      Password for local validation
	 * @returns           {boolean}     true if valid, false otherwise
	 */
	var ValidateFormField = function(password) {
		var result = Validate(password);
		return result.Pass;
	};

	/**
	 *
	 * @param   string      password
	 * @returns {PolicyResult}
	 * @constructor
	 */
	var Validate = function(password) {
		var result = new PolicyResult();

		if (!password || password.length == 0) {
			result.Pass=false;
			result.Tests.Empty=false;

			password = '';
		}

		if (password.length < options.Policy.Length) {
			result.Pass = false;
			result.Tests.Length = false;
		}



		// if (options.Policy.RepetitiveChars > 0) {
	    //      var matchrepetitive = password.match(new RegExp('(.)\\1{' + options.Policy.RepetitiveChars + ',}'));
		// 		if (matchrepetitive) {
		// 			result.Pass = false;
		// 			result.Tests.RepetitiveChars = false;
		// 		}
		//
		// }

		var matchwhitespace = password.match(/\s/g);
		if (matchwhitespace) {
			result.Pass = false;
			result.Tests.Whitespaces = false;

		}

		var matchdigits = password.match(/[0-9]{1}/g);
		if (options.Policy.Digits > (!matchdigits ? 0: matchdigits.length)) {
			result.Pass = false;
			result.Tests.Digits = false;

		}

		var matchlowercase = password.match(/[a-z]{1}/g);
		if (options.Policy.LowerCase > (!matchlowercase ? 0: matchlowercase.length)) {
			result.Pass = false;
			result.Tests.LowerCase = false;

		}
		var matchuppercase = password.match(/[A-Z]{1}/g);
		if (options.Policy.UpperCase > (!matchuppercase ? 0: matchuppercase.length)) {
			result.Pass = false;
			result.Tests.UpperCase = false;

		}
		var matchspecial = password.match(/[^A-Za-z0-9]{1}/g);
		if (options.Policy.SpecialChars > (!matchspecial ? 0: matchspecial.length)) {
			result.Pass = false;
			result.Tests.SpecialChars = false;

		}

		return result;
	};

	var serverResponseCB = function(data) {
		me.Errors = data.Errors ? data.Errors : [];
		if (options.Fields.Errors != null) {
			var field_name = {};
			field_name[$(field).prop('name')] = {"server_error_clear": ""}
			validate_obj.showErrors(field_name);
			$(options.Fields.Errors).removeClass("server-errors");

		}

		if (options.Fields.Errors != null && me.Errors.length > 0) {
			var field_name = {};
			field_name[$(field).prop('name')] = {"server_error": me.Errors}
		      validate_obj.showErrors(field_name);

		      $(options.Fields.Errors).html($.render.PasswordPolicyError({
		        ServerErrors: me.Errors
		      }));
		      $(options.Fields.Errors).addClass("server-errors");
		}
	}


	/**
	 *  internal Initializer
	 * @constructor
	 */
	var Init = function () {
		// add (local) password policy rule to validator
		$.validator.addMethod('passwordPolicyLocal', function(value, element) {
			return this.optional(element) || ValidateFormField(value);
		});

    // var func = function() {
    //   console.log(options);
    // };
    //
    // func();

    // $.when($.Deferred().resolve()).done(func);

		// define class rule
		$.validator.addClassRules(
			'password-policy',
			{
				required: true,
				passwordPolicyLocal: true,
				remote: {
					url: API.URL + '/PasswordPolicy',
					type: 'post',
					processData: false,
					global:false,
					data: {
						Password: '123'
					},
					beforeSend: function (jqXHR, jqOptions) {
						if (jqOptions.contentType == "application/json" && typeof jqOptions.data != "string") {

							var additionalData = options.UserData.slice();
							var currentPassword = null;
							var username = null;
							var firstname=null;
							var lastname = null;

							if (options.EMail) {
								username = options.EMail;
							} else if (options.Fields.EMail) {
								username = options.Fields.EMail.val();
							}
							if (options.Fields.CurrentPassword) {
								currentPassword = options.Fields.CurrentPassword.val();
							}


							if (options.Fields.FirstName) {
								firstname = options.Fields.FirstName.val();

								if (firstname) {
									additionalData.push(firstname);
								}
							}

							if (options.Fields.LastName) {
								lastname = options.Fields.LastName.val();

								if (lastname) {
									additionalData.push(lastname);
								}
							}

							if (firstname && lastname) {
								additionalData.push(firstname + ' ' + options.Fields.LastName.val());
							}



							jqOptions.data = JSON.stringify({
								Password: field.val(),
								UserID: options.UserID,
								Username: username,
								CurrentPassword: currentPassword,
								AdditionalData: additionalData
							});
						}
					},
					contentType: 'application/json',
					headers: {
						'X-API-Version': API.Version,
						'Accept': 'application/json',
					},
					converters: {
						'text json': function (raw) {
							var result = JSON.parse(raw);
							if (typeof server_response_cb === 'function') {
								server_response_cb(result);
							}
              serverResponseCB(result);
							return result.Pass;
						}
					}
				}
			}
		);

		field.addClass('password-policy');

		if (options.Fields.PolicyDescription) {
			RenderPolicy();
		}

    $(field).on('keyup focusout', function() {
      var result = me.getRulesResult($(this).val()),
          elements = getPasswordField();

      for (var key in elements) {
        if (elements.hasOwnProperty(key)) {
          if (result.Tests[key]) {
            elements[key].removeClass('not-passing');
            elements[key].addClass('passing');
          } else {
            elements[key].addClass('not-passing');
            elements[key].removeClass('passing');
          }
        }
      }

    });
	};

  var getPasswordField = function() {
    return {
      Length: options.Fields.PolicyDescription.find('.length'),
      LowerCase: options.Fields.PolicyDescription.find('.lower'),
      UpperCase: options.Fields.PolicyDescription.find('.upper'),
      SpecialChars: options.Fields.PolicyDescription.find('.special'),
      Digits: options.Fields.PolicyDescription.find('.digits')
    }
  }


	var RenderPolicy = function() {
		if (!options.Fields.PolicyDescription) {
			return;
		}

		var that = this,
        messages = {};

		if (options.Policy.Length > 0) {
			messages.Length = $.ngettext('one character', '%s characters', options.Policy.Length).replaceAll('%s', options.Policy.Length);
		}

		if (options.Policy.Digits > 0) {
			messages.Digits = $.ngettext('one numeral', '%s numerals', options.Policy.Digits).replaceAll('%s', options.Policy.Digits );
		}

		if (options.Policy.LowerCase > 0) {
			messages.LowerCase = $.ngettext('one lowercase letter', '%s lowercase letters',options.Policy.LowerCase).replaceAll('%s', options.Policy.LowerCase);
		}
		if (options.Policy.UpperCase > 0) {
			messages.UpperCase = $.ngettext('one uppercase letter', '%s uppercase letters', options.Policy.UpperCase).replaceAll('%s', options.Policy.UpperCase);
		}
		if (options.Policy.SpecialChars > 0) {
			messages.SpecialChars = $.ngettext('one special character', '%s special characters',options.Policy.SpecialChars).replaceAll('%s', options.Policy.SpecialChars);
		}

    options.Fields.PolicyDescription.html(
        $.render.PasswordPolicy({
          Messages: messages,
					ServerErrors: me.Errors
        })
    );

    options.Fields.PolicyDescription.fadeIn().css('display','');
	};

	Init();


};

export { PasswordValidator }


